// file: Drive.tsx
import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import Dropdown from "react-bootstrap/Dropdown";
import { useDriveContext } from "../../../../contexts/DriveContext";
import searchicon from "../../../../assets/images/searchicon.svg";
import { Plus } from "lucide-react";
import Pagination from "../../../ui/Pagination/Pagination";
import "./drive.css";
import MoveFileModal from "./personalDrive/Modals/MoveFileModal";
import { Button } from "react-bootstrap";
interface DriveProps {
  employeeId?: string;
}

const Drive: React.FC<DriveProps> = ({ employeeId }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { 
    searchTerm, 
    setSearchTerm, 
    onFileUploadClick, 
    onFolderCreateClick,
    pagination,
    setPagination,
    totalItems,
    setTotalItems,
    selectedFileIds,
    setSelectedFileIds,
    showMoveModal,
    setShowMoveModal,
    refreshCurrentFolder,
    currentFolderId
  } = useDriveContext();

  const getActiveKey = () => {
    if (location.pathname.startsWith("/drive/caseFileDrive")) {
      return "participantfiles";
    } else if (location.pathname.startsWith("/drive/personal")) {
      return "personal";
    } else if (location.pathname.startsWith("/drive/employee-files")) {
      return "employee-files";
    }
    return "participantfiles"; // Default fallback
  };

  const activeKey = getActiveKey();

  // Get placeholder text based on active tab
  const getSearchPlaceholder = () => {
    switch (activeKey) {
      case "participantfiles":
        return "Search participant files";
      case "personal":
        return "Search Files";
      case "employee-files":
        return "Search employee files";
      default:
        return "Search Files";
    }
  };

  // Reset search term, pagination, and total items when tab changes
  useEffect(() => {
    setSearchTerm("");
    setPagination({ pageNumber: 1, pageSize: 10 });
    setTotalItems(0);
    setSelectedFileIds([]);
    setShowMoveModal(false);
  }, [activeKey, setSearchTerm, setPagination, setTotalItems, setSelectedFileIds, setShowMoveModal]);

  // Pagination handlers
  const onPageChange = (pageNum: number) => {
    setPagination((prev) => ({
      ...prev,
      pageNumber: pageNum,
    }));
  };

  const resetPageSize = (pageNumber: number, pageSize: number) => {
    setPagination({
      pageNumber: pageNumber,
      pageSize: pageSize,
    });
  };

  const totalPages = Math.ceil(totalItems / pagination.pageSize);

  return (
    <>
      {/* {loading && <Loader />} */}

      <div className="tasks_page_container shadow-sm drive-context-container">
        <Tab.Container id="left-tabs-example" activeKey={activeKey}>
          <div className="drive_header_container">
            <div className="drive_tabs_wrapper">
              <Nav variant="pills" className="common_tab drive_tab">
                <Nav.Item>
                  <Nav.Link
                    eventKey="participantfiles"
                    onClick={() => navigate("/drive/caseFileDrive")}
                  >
                    Participant Files
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    eventKey="personal"
                    onClick={() => navigate("/drive/personal")}
                  >
                    Personal Files
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    eventKey="employee-files"
                    onClick={() => navigate("/drive/employee-files")}
                  >
                    Employee Files
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </div>
            
            <div className="drive_search_wrapper flex items-center  gap-3 ">
            {activeKey === "personal" && selectedFileIds.length > 0 && (
              <Button 
                onClick={() => setShowMoveModal(true)} 
                variant="submit-btn"
                className="btn btn-primary submit-btn"
              >
                Move
              </Button>
            )}
            {activeKey === "personal" && (
              <div className="drive_add_new_wrapper">
                <Dropdown className="my_dropdown my_dropdown_primary" autoClose={true}>
                  <Dropdown.Toggle variant="submit-btn" id="dropdown-basic1">
                    <Plus className="w-[16px] h-[16px]" /> Add New File
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end" className="p-[0.3rem]">
                    <Dropdown.Item 
                      onClick={() => {
                        if (onFileUploadClick) {
                          onFileUploadClick();
                        }
                        // Bootstrap will close the dropdown automatically
                      }}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 16" fill="none">
  <path d="M8 2V10" stroke="#717182" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M11.3346 5.33333L8.0013 2L4.66797 5.33333" stroke="#717182" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10" stroke="#717182" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                      <span>Upload File</span>
                    </Dropdown.Item>
                    <Dropdown.Item 
                      onClick={() => {
                        if (onFolderCreateClick) {
                          onFolderCreateClick();
                        }
                        // Bootstrap will close the dropdown automatically
                      }}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 16" fill="none">
  <path d="M8 6.66667V10.6667" stroke="#717182" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6 8.66667H10" stroke="#717182" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M13.332 13.3333C13.6857 13.3333 14.0248 13.1929 14.2748 12.9428C14.5249 12.6928 14.6654 12.3536 14.6654 12V5.33333C14.6654 4.97971 14.5249 4.64057 14.2748 4.39052C14.0248 4.14048 13.6857 4 13.332 4H8.06536C7.84237 4.00219 7.6224 3.94841 7.42556 3.84359C7.22873 3.73877 7.06134 3.58625 6.9387 3.4L6.3987 2.6C6.27729 2.41565 6.11201 2.26432 5.9177 2.1596C5.72338 2.05488 5.5061 2.00004 5.28536 2H2.66536C2.31174 2 1.9726 2.14048 1.72256 2.39052C1.47251 2.64057 1.33203 2.97971 1.33203 3.33333V12C1.33203 12.3536 1.47251 12.6928 1.72256 12.9428C1.9726 13.1929 2.31174 13.3333 2.66536 13.3333H13.332Z" stroke="#717182" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                      <span>New Folder</span>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            )}
              <div className="custom_input_flled filled_input_icon mb-0">
                <input
                  type="search"
                  placeholder={getSearchPlaceholder()}
                  className="sm_input drive_search_input"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <span className="icon_img cursor-pointer">
                  <img src={searchicon} alt="search" />
                </span>
              </div>
            </div>
          </div>
          <Tab.Content>
            <Outlet />
          </Tab.Content>
          {/* Common Pagination for all tabs */}
         
        </Tab.Container>
        {totalItems > 0 && (
            
              <Pagination
             
                currentPage={pagination.pageNumber}
                totalPages={totalPages}
                onPageChange={onPageChange}
                pageSize={pagination.pageSize}
                resetPageSize={resetPageSize}
              />
            
          )}
      </div>
     
      {showMoveModal && refreshCurrentFolder && (
        <MoveFileModal
          show={showMoveModal}
          handleClose={() => {
            setSelectedFileIds([]);
            setShowMoveModal(false);
          }}
          selectedFileIds={selectedFileIds}
          refreshCurrentFolder={refreshCurrentFolder}
          sourceFolderId={currentFolderId}
        />
      )}
    </>
  );
};

export default Drive;
